import {
  ChangeDetectionStrategy,
  Component,
  Input,
  type OnChanges,
  type OnInit,
  type SimpleChanges,
} from '@angular/core';
import { LinkColor } from '@freelancer/ui/link';
import { textVariants } from '@freelancer/ui/tailwind-text';
import { FontColor, TextSize } from '@freelancer/ui/text';

@Component({
  standalone: false,
  selector: 'app-manage-quotation-title',
  template: `
    <div class="Title">
      <fl-link
        class="mr-xxsmall"
        [flTrackingLabel]="'QuotationTitleClick'"
        [flTrackingReferenceType]="'quotation_uid'"
        [flTrackingReferenceId]="quotationUid"
        [link]="'/quotation/' + quotationUid + '/view'"
        [color]="LinkColor.INHERIT"
      >
        <p
          [class]="cls"
          [flMaxLines]="2"
        >
          {{ titleText }}
        </p>
      </fl-link>
    </div>
  `,
  styleUrls: ['./manage-quotation-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageQuotationTitleComponent implements OnInit, OnChanges {
  LinkColor = LinkColor;

  @Input() quotationUid: string;
  @Input() size: TextSize = TextSize.BODY_16;
  @Input() sizeTablet: TextSize = TextSize.BODY_16;
  @Input() titleText: string;

  cls: string;

  ngOnInit(): void {
    this.computeClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('size' in changes || 'sizeTablet' in changes) {
      this.computeClasses();
    }
  }

  private computeClasses(): void {
    this.cls = textVariants({
      color: FontColor.INHERIT,
      size: this.size,
      sizeTablet: this.sizeTablet,
    });
  }
}
